import React from "react"
import TypeformEmbed from "../common/TypeformEmbed"

const CancellationRequestPage = () => {
  return <TypeformEmbed id="lV8q9Bh6" />
}

export default CancellationRequestPage
